module.exports = __webpack_public_path__ + "static/comfort_pietro-8699c4ac9ada3a2075f90df52ca6e8c8.jpg";